import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import {
  hasAnonLogin,
  hasAutoJoin,
} from "modules/queryParams/queryParamsHelper";

type Action = "EVENT_FULL" | "EVENT_ENDED" | "NONE";

export const Actions: Record<string, Action> = {
  FULL: "EVENT_FULL",
  ENDED: "EVENT_ENDED",
  NONE: "NONE",
};

const parseAction = (action: string | null) => {
  switch (action) {
    case Actions.FULL: {
      return Actions.FULL;
    }
    case Actions.ENDED: {
      return Actions.ENDED;
    }
    default: {
      return Actions.NONE;
    }
  }
};

export const useEventLandingPageParameters = () => {
  const params = useQueryParams();
  const isAutoJoin = hasAutoJoin(params);

  return {
    autojoin: isAutoJoin,
    triggerAnonymousLogin: hasAnonLogin(params),
    action: parseAction(params.action as string | null),
  };
};
